module.exports = __webpack_public_path__ + "img/dz_bodzavirag80.821c6160.jpg";